import ApiService from "../../utils/fetch";
const userRolesUrl = `${process.env.REACT_APP_BASE_URL}user-access/`;

export const addDelegation = async (payload) => {
  const url = `${userRolesUrl}createDelegation`;
  const response = await ApiService.post(url, payload);
  return response.data;
};

export const getDelegations = async (userEmail) => {
  const url = `${userRolesUrl}getDelegations?userEmail=${encodeURIComponent(userEmail)}`;
  const response = await ApiService.get(url);
  return response.data;
};

export const deleteDelegation = async (seqId) => {
  const url = `${userRolesUrl}deleteDelegation/${seqId}`;
  const response = await ApiService.delete(url);
  return response.data;
};

